import { createClient } from '@sanity/client'
export default createClient({
  projectId: 'tq4wzdvz',
  dataset:
    process.env.REACT_APP_ENV === 'development' ? 'development' : 'production',
  token: process.env.REACT_APP_SANITY_TOKEN,
})
